<template>
  <div class="main" style="min-height: 768px;">
    <section class="panel">
      <header class="panel-heading">
        <h2 class="panel-title">宿舍管控卡片設定</h2>
      </header>
      <div class="panel-body container-fluid">
        <div class="row form-group">
          <div class="col-md-4 form-group">
            <label class="col-xs-4 col-md-5">卡號(流水編號)</label>
            <div class="col-xs-8 col-md-7">
              <input type="text" class="form-control" maxlength="20" v-model.trim="form.cardNo">
            </div>
          </div>
          <div class="col-md-4 form-group">
            <label class="col-xs-4 col-md-5">卡片模式</label>
            <div class="col-xs-8 col-md-7">
              <select class="form-control" v-model="form.cardMode">
                <option value="">請選擇</option>
                <option v-for="item in cardModeList" :key="'card-mode-' + item.value" :value="item.value">{{ item.text }}</option>
              </select>
            </div>
          </div>
          <div class="col-md-4 form-group">
            <label class="col-xs-4 col-md-5">姓名</label>
            <div class="col-xs-8 col-md-7">
              <input type="text" class="form-control" maxlength="50" v-model.trim="form.name">
            </div>
          </div>
        </div>

        <div class="row form-group">
          <div class="col-md-4 form-group">
            <label class="col-xs-4 col-md-5">學年度</label>
            <div class="col-xs-8 col-md-7">
              <select class="form-control" v-model="form.schYear">
                <option :value="null">請選擇</option>
                <option v-for="item in schYearList" :key="item" :value="item">{{ item }}</option>
              </select>
            </div>
          </div>
          <div class="col-md-4 form-group">
            <label class="col-xs-4 col-md-5">學期</label>
            <div class="col-xs-8 col-md-7">
              <select class="form-control" v-model="form.semester">
                <option :value="null">請選擇</option>
                <option v-for="item in semesterList" :key="item" :value="item">{{ item }}</option>
              </select>
            </div>
          </div>
          <div class="col-md-4 form-group">
            <label class="col-xs-4 col-md-5">部門(房號)</label>
            <div class="col-xs-8 col-md-7">
              <input type="text" class="form-control" maxlength="20" v-model.trim="form.roomNo">
            </div>
          </div>
        </div>

        <div class="row form-group">
          <div class="col-md-4 form-group">
            <label class="col-xs-4 col-md-5">員工編號(學號)</label>
            <div class="col-xs-8 col-md-7">
              <input type="text" class="form-control" maxlength="20" v-model.trim="form.account">
            </div>
          </div>
          <div class="col-md-4 form-group">
            <label class="col-xs-4 col-md-5">門組</label>
            <div class="col-xs-8 col-md-7">
              <select class="form-control" v-model="form.doorGroup">
                <option value="">請選擇</option>
                <option v-for="item in doorGroupList" :key="'door-group-' + item.value" :value="item.value">{{ item.text }}</option>
              </select>
            </div>
          </div>
          <div class="col-md-4 form-group">
            <label class="col-xs-4 col-md-5">時區</label>
            <div class="col-xs-8 col-md-7">
              <input type="text" class="form-control" maxlength="20" v-model.trim="form.timeZone">
            </div>
          </div>
        </div>

        <div class="row form-group">
          <div class="col-md-4 form-group">
            <label class="col-xs-4 col-md-5">身份證字號</label>
            <div class="col-xs-8 col-md-7">
              <input type="text" class="form-control" maxlength="20" v-model.trim="form.idno">
            </div>
          </div>
          <div class="col-md-4 form-group">
            <label class="col-xs-4 col-md-5">期限日期</label>
            <div class="col-xs-8 col-md-7">
              <datepicker
                :format="customFormatter"
                :language="zh"
                v-model="form.expireDate"
                input-class="form-control topIndex"
                :style="{ width: '100%', display: 'inline-block' }"
              />
            </div>
          </div>
          <div class="col-md-4 form-group">
            <label class="col-xs-4 col-md-5">實際編碼</label>
            <div class="col-xs-8 col-md-7">
              <input type="text" class="form-control" maxlength="40" v-model.trim="form.actualCode">
            </div>
          </div>
        </div>

        <div class="row form-group">
          <div class="col-md-4 form-group">
            <label class="col-xs-4 col-md-5">性別</label>
            <div class="col-xs-8 col-md-7">
              <select class="form-control" v-model="form.sex">
                <option value="">（不填）</option>
                <option value="男">男</option>
                <option value="女">女</option>
              </select>
            </div>
          </div>
          <div class="col-md-4 form-group">
            <label class="col-xs-4 col-md-5">進出管制</label>
            <div class="col-xs-8 col-md-7">
              <select class="form-control" v-model="form.entryControl">
                <option value="">請選擇</option>
                <option v-for="item in yesNoList" :key="'entry-' + item.value" :value="item.value">{{ item.text }}</option>
              </select>
            </div>
          </div>
          <div class="col-md-4 form-group">
            <label class="col-xs-4 col-md-5">樓層管制</label>
            <div class="col-xs-8 col-md-7">
              <select class="form-control" v-model="form.floorControl">
                <option value="">請選擇</option>
                <option v-for="item in floorControlList" :key="'floor-' + item.value" :value="item.value">{{ item.text }}</option>
              </select>
            </div>
          </div>
        </div>

        <div class="row form-group">
          <div class="col-md-offset-4 col-md-2">
            <a href="javascript:;" class="btn s_btn_b btn-block" @click="clickPrevious">返回</a>
          </div>
          <div class="col-md-2">
            <a href="javascript:;" class="btn btn-primary btn-block" @click="saveCard">儲存</a>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
/* global bootbox */

function buildSchYearList() {
  const list = [];
  let currentYear = new Date().getFullYear() - 1911;
  for (let year = currentYear + 1; year >= 100; year -= 1) {
    list.push(year);
  }
  return list;
}

function createDefaultForm() {
  return {
    id: null,
    schYear: null,
    semester: null,
    cardNo: "",
    cardMode: "",
    name: "",
    sex: "",
    roomNo: "",
    account: "",
    doorGroup: "",
    timeZone: "",
    idno: "",
    expireDate: null,
    actualCode: "",
    entryControl: "",
    floorControl: "",
  };
}

export default {
  data() {
    return {
      form: createDefaultForm(),
      schYearList: buildSchYearList(),
      semesterList: [1, 2],
      yesNoList: [
        { value: "Y", text: "是" },
        { value: "N", text: "否" },
      ],
      cardModeList: [],
      doorGroupList: [],
      floorControlList: [],
    };
  },
  async mounted() {
    if (!this.guardAccess()) {
      return;
    }
    await this.loadInit();
    if (this.$route.query.id) {
      await this.loadDetail(this.$route.query.id);
    }
  },
  methods: {
    guardAccess() {
      if (this.isAdmin("stay")) {
        return true;
      }
      bootbox.alert("無宿舍管控卡片設定權限", () => {
        this.$router.replace({ name: "stay.list" });
      });
      return false;
    },
    async loadInit() {
      const resp = await this.$axios.get("/api/DormitoryAccessCard/init");
      if (resp.data.status !== "success") {
        bootbox.alert(resp.data.msg || "取得初始化資料失敗");
        return;
      }
      if (resp.data.data && resp.data.data.yesNoList) {
        this.yesNoList = resp.data.data.yesNoList;
      }
      if (resp.data.data && resp.data.data.cardModeList) {
        this.cardModeList = resp.data.data.cardModeList;
      }
      if (resp.data.data && resp.data.data.doorGroupList) {
        this.doorGroupList = resp.data.data.doorGroupList;
      }
      if (resp.data.data && resp.data.data.floorControlList) {
        this.floorControlList = resp.data.data.floorControlList;
      }
    },
    async loadDetail(id) {
      const resp = await this.$axios.get(`/api/DormitoryAccessCard/detail/${id}`);
      if (resp.data.status !== "success") {
        bootbox.alert(resp.data.msg || "取得宿舍管控卡片資料失敗", () => {
          this.clickPrevious();
        });
        return;
      }

      this.form = {
        ...createDefaultForm(),
        ...resp.data.data,
        expireDate: resp.data.data.expireDate ? new Date(resp.data.data.expireDate) : null,
      };
    },
    validateForm() {
      const fieldMap = [
        [this.form.cardNo, "卡號(流水編號)"],
        [this.form.cardMode, "卡片模式"],
        [this.form.name, "姓名"],
        [this.form.schYear, "學年度"],
        [this.form.semester, "學期"],
        [this.form.roomNo, "部門(房號)"],
        [this.form.account, "員工編號(學號)"],
        [this.form.doorGroup, "門組"],
        [this.form.timeZone, "時區"],
        [this.form.idno, "身份證字號"],
        [this.form.expireDate, "期限日期"],
        [this.form.actualCode, "實際編碼"],
        [this.form.entryControl, "進出管制"],
        [this.form.floorControl, "樓層管制"],
      ];

      const missing = fieldMap.filter(([value]) => !value).map(([, label]) => label);
      return missing;
    },
    validateLength() {
      const lengthMap = [
        [this.form.cardNo, "卡號(流水編號)", 20],
        [this.form.name, "姓名", 50],
        [this.form.roomNo, "部門(房號)", 20],
        [this.form.account, "員工編號(學號)", 20],
        [this.form.timeZone, "時區", 20],
        [this.form.idno, "身份證字號", 20],
        [this.form.actualCode, "實際編碼", 40],
      ];

      return lengthMap
        .filter(([value, , max]) => value && value.length > max)
        .map(([, label, max]) => `${label}（上限 ${max} 字）`);
    },
    saveCard() {
      const missing = this.validateForm();
      if (missing.length) {
        bootbox.alert(`請確認以下欄位已填寫：${missing.join('、')}`);
        return;
      }

      const tooLong = this.validateLength();
      if (tooLong.length) {
        bootbox.alert(`以下欄位長度超過限制：${tooLong.join('、')}`);
        return;
      }

      const payload = {
        ...this.form,
        schYear: Number(this.form.schYear),
        semester: Number(this.form.semester),
        expireDate: this.form.expireDate ? this.customFormatter(this.form.expireDate, "YYYY-MM-DD") + "T00:00:00" : null,
      };

      this.$axios.post("/api/DormitoryAccessCard/save", JSON.stringify(payload)).then((resp) => {
        if (resp.data.status !== "success") {
          bootbox.alert(resp.data.msg || "儲存失敗");
          return;
        }

        bootbox.alert("儲存成功", () => {
          this.clickPrevious();
        });
      });
    },
    clickPrevious() {
      this.$router.push({ name: "stay.accessCard" });
    },
  },
};
</script>